import get from 'lodash/get';

export default searchResults =>
	get(
		searchResults,
		['hotelOptions', '0', 'roomRates', '0', 'prices', '0', 'total', 'cash', 'currencyCode'],
		''
	);
